import cn from 'classnames';
import * as React from 'react';

import { getFavorites } from '../../../client/services/favorites';
import {
  deleteAllNotifications,
  getHasNewNotifications,
  getNotifications,
  markAllNotificationAsRead,
  markNotificationAsRead,
} from '../../../client/services/notificationCenter';

import { ChatsNotificator } from '../../chats_notificator';
import { TopMenuContainer } from '../../containers/TopMenuContainer';

import { GroupIcons } from '../GroupIcons';

import {
  CianLogo,
  Favourites,
  HeaderUserMenu,
  LoginView,
  Notifications,
  PrivateOffice,
  Searched,
} from './internal/components';
import { PlaceAdContainer } from './internal/containers/PlaceAdContainer';
import { BottomMenuProps } from './types';

const styles = require('./BottomMenu.css');

export const BottomMenu: React.FC<BottomMenuProps> = props => {
  const {
    httpApi,
    addObjectLink,
    dropdownMenusData,
    favLink,
    hasNotBlockedSanction,
    headerData,
    isBorderedBottom,
    isDobroshriftEnabled,
    isErroneous,
    isShadowDisabled,
    isStatic,
    isFavoritesMarkerEnabled,
    linksBaseUrl,
    newHeaderEnabled = true,
    notificationCenterData,
    notificationsLink,
    searchLink,
    section,
    specialPromoLinkData,
    subdomain,
    regionId,
    isCianProEnabled,
    dealRentLinkExperiment,
  } = props;

  return (
    <div
      className={cn('c-header-bottom', {
        'c-header-bottom--no_shadow': isShadowDisabled,
        'c-header-bottom--bordered_bottom': isBorderedBottom,
      })}
    >
      <div id="header-container" className="c-header-container">
        <div className="c-header-container-row">
          <div className="c-header-bottom__mobile-nav-wrap" id="burger">
            <span className="c-header-bottom__mobile-nav-btn">
              <span className="c-header-bottom__mobile-nav-baton" />
              <span className="c-header-bottom__mobile-nav-baton" />
              <span className="c-header-bottom__mobile-nav-baton" />
            </span>
          </div>

          <CianLogo isDobroshriftEnabled={isDobroshriftEnabled} link={`//${subdomain}.${linksBaseUrl}`} />

          <div className={cn('c-header-col', 'c-header-right-container', 'c-header-bottom-menu-wrap')}>
            <div id="bottom-menu-titles">
              <TopMenuContainer
                activeKey={section}
                dropdownMenusData={dropdownMenusData}
                headerData={headerData}
                specialPromoLinkData={specialPromoLinkData}
                regionId={regionId}
                isCianProEnabled={isCianProEnabled}
                dealRentLinkExperiment={dealRentLinkExperiment}
              />
            </div>

            <div className="c-header-bottom_right-panel">
              <div className="c-header-bottom_right-panel_wrapper">
                <div className="c-header-messages" id="header-chats-icon">
                  {headerData.isAuthenticated && (
                    <ChatsNotificator
                      baseUrl={`//${linksBaseUrl}`}
                      isAuthenticated={true}
                      notificationsCount={null}
                      section={section}
                    />
                  )}
                </div>

                <div id="header-icons-btn" className="c-header-groups-icon">
                  <GroupIcons
                    httpApi={httpApi}
                    baseUrl={`//${linksBaseUrl}`}
                    deleteAllNotifications={deleteAllNotifications}
                    favLink={`//${subdomain}.${linksBaseUrl}/rent/flat/favorites/`}
                    getFavorites={getFavorites}
                    getHasNewNotifications={getHasNewNotifications}
                    getNotifications={getNotifications}
                    headerData={headerData}
                    markAllNotificationAsRead={markAllNotificationAsRead}
                    markNotificationAsRead={markNotificationAsRead}
                    newHeaderEnabled={newHeaderEnabled}
                    notificationCenterData={notificationCenterData}
                    subdomain={subdomain}
                  />
                </div>

                <div className="user-container">
                  <PlaceAdContainer
                    hasNotBlockedSanction={hasNotBlockedSanction}
                    section={section}
                    addObjectLink={addObjectLink}
                  />

                  <HeaderUserMenu headerData={headerData} />
                </div>

                {headerData.isAuthenticated && (
                  <PrivateOffice link={headerData.lkUrl ?? '#'} username={headerData.displayUsername ?? null} />
                )}

                {!headerData.isAuthenticated && <LoginView />}
              </div>

              {headerData.isAuthenticated && (
                <Notifications
                  count={headerData.notificationsCount}
                  link={notificationsLink}
                  lkType={headerData.lkType ?? null}
                  notificationCenterData={notificationCenterData}
                  subdomain={subdomain}
                />
              )}

              {headerData.isAuthenticated && <Searched count={headerData.storedFiltersCount} link={searchLink} />}

              {!isStatic && !isErroneous && (
                <Favourites link={favLink} count={headerData.favoritesCount} withMarker={isFavoritesMarkerEnabled} />
              )}
            </div>
          </div>
        </div>
        <div className={styles['geo-switcher-container']}>
          <div id="header_geo_switcher" className={styles['geo-switcher']} />
        </div>
      </div>
    </div>
  );
};

BottomMenu.displayName = 'BottomMenu';
